import React from "react";
import { Stack } from "@mantine/core";
import WebsiteGeneratorTitlePage from "./WebsiteGeneratorTitlePage";
import WebsiteGoogleAnalytics from "./WebsiteGoogleAnalytics";
import WebsiteCustomizeOption from "./WebsiteCustomizeOption";

const WebsiteCustomizationTab: React.FC = () => {
  return (
    <Stack gap="md">
      <WebsiteGeneratorTitlePage />
      <WebsiteGoogleAnalytics />
      <WebsiteCustomizeOption />
    </Stack>
  );
};

export default WebsiteCustomizationTab;
